/**
 * Preset frequencies for EQ presets (centralized)
 *
 * Exported as `presetFrequencies` to be consumed by config and exporters.
 */

export const presetFrequencies: number[] = [32, 62, 125, 250, 500, 800, 1000, 1300, 2000, 3000, 4000, 5000, 7000, 9000, 11000, 13000, 15000, 17000, 18000];

export default presetFrequencies;